export enum AlertIconClass {
  red = 'fa fa-times-circle circle_red',
  yellow = 'fa fa-exclamation-triangle circle_orange enhanced-warning-icon',
  green = 'fa fa-check circle_green'
}
